export const copyBankAccountNumber = async () => {
    const nr = document.querySelector("#nr-rachunku");
    const icon = document.querySelector(".copy-icon");
    const msg = document.querySelector(".copy-message");
    if(nr) {
        icon.addEventListener("click",async ()=>{
            navigator.clipboard.writeText(nr.innerText);
            msg.classList.add("copy-message-animation");
            await new Promise(r => setTimeout(r, 2000));
            msg.classList.remove("copy-message-animation");
        })
    }
 }
 